import { render } from "./RenewCart.vue?vue&type=template&id=2c5c1351&scoped=true"
import script from "./RenewCart.vue?vue&type=script&lang=js"
export * from "./RenewCart.vue?vue&type=script&lang=js"

import "./RenewCart.vue?vue&type=style&index=0&id=2c5c1351&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5c1351"]])

export default __exports__